import { ActivityLogActionTypes } from './constants';
import { PAGINATION_DEFAULT_VALUE } from '../../helpers/defaultValue';

const INIT_STATE = {
    loading: false,
    error: null,
    logEntries: null,
    pagination: PAGINATION_DEFAULT_VALUE,
};

type ActivityLogAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

type State = {
    loading: Boolean,
    error?: null,
    logEntries: any,
    pagination: any,
};

const ActivityLog = (state: State = INIT_STATE, action: ActivityLogAction): any => {
    switch (action.type) {
        case ActivityLogActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ActivityLogActionTypes.GET_LOG_ENTRIES: {
                    return {
                        ...state,
                        loading: false,
                        logEntries: action.payload.data.logEntries,
                        pagination: { ...PAGINATION_DEFAULT_VALUE, ...action.payload.data.pagination },
                    };
                }
                default:
                    return { ...state, loading: false };
            }

        case ActivityLogActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ActivityLogActionTypes.GET_LOG_ENTRIES: {
                    return { ...state, loading: false, error: action.payload.error };
                }
                default:
                    return { ...state, loading: false };
            }

        case ActivityLogActionTypes.GET_LOG_ENTRIES:
            return { ...state, loading: true, logEntries: null };
        case ActivityLogActionTypes.RESET_STATE:
            return INIT_STATE;
        default:
            return { ...state };
    }
};

export default ActivityLog;
